<div class="login-screen">
    <div class="wrapper-reponsive">
            <!-- Start màn 2 -->
        <div class="content-box mt-2 mb-4 p-4">
            <div class="tlt-green-row mb-2">
                {{'STR_SEND_PW_RESET_EMAIL'| translate}} 
            </div>
            <p class="p-2">
                {{'STR_NOTICE_RESET_EMAIL' | translate   }}
            </p>
            <div class="row-input row-input-auto-height p-4 mb-4">
                <div class="pl-3">
                    <div class="tlt-dot mb-1">{{'STR_EMAIL_ADDRESS' | translate}}</div>
                    <input (keyup)="toLowerCase()" (keydown)="removeErr()" [ngClass]="{'error-border': isErrMail }" type="text" [(ngModel)]="maillAdress" maxlength="255" class="form-control mb-3">
                    <div  *ngIf="isErrMail" class="err-validate">
                        <span>{{messErrMail | translate}}</span>
                    </div>
                </div>
            </div>
            <div class="text-center mt-2" style="margin-bottom: 15px">
                <button class="btn btn-common btn-bg-green mb-2" (click)="Reset()">
                    {{'STR_BTN_SEND_MAIL'| translate}}
                </button> <br>
                <button class="btn btn-common btn-bg-yellow"(click)="BackLogin()">
                    {{'STR_BTN_BACK'| translate}}
                    </button>
            </div>
        </div>
        <!-- End màn 2 -->
    </div>
</div>